module.exports = __webpack_public_path__ + "static/media/py.dd93162b.svg";